export var ABTestID;
(function (ABTestID) {
    ABTestID["PLG"] = "50_percent_traffic_widget_display";
    ABTestID["LIVE_HELPER_IDLE_VARIANT"] = "live_helper_idle_expanded_1";
    ABTestID["AVA_IN_PLAYER_ANSWER_ACTION"] = "ava_in_player_answer_action";
})(ABTestID || (ABTestID = {}));
